export const timeRange = "ec4Mw";
export const timeRangeDifferentDay = "rZIsLc";
export const timeRangeTimeZoneTransition = "OH83ve";
export const timeRangeDifferentDayTimeZoneTransition = "VlF4ke";
export default {timeRange,timeRangeDifferentDay,timeRangeTimeZoneTransition,timeRangeDifferentDayTimeZoneTransition};